(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initBuybox(e.target);
  });

  function initAll() {
    document.querySelectorAll('.wmc-buybox').forEach(function (box) {
      initBuybox(box.closest('.shopify-section') || box);
    });
  }

  function initBuybox(scope) {
    const buybox = scope.querySelector('.wmc-buybox');
    if (!buybox || buybox.dataset.wmcInit === 'true') return;
    buybox.dataset.wmcInit = 'true';

    document.body.classList.add('pricing-onetime-mode', 'wmc-product-page');

    const optionsMount = buybox.querySelector('.js-product-options-mount');
    const optionsForm = buybox.querySelector('.wmc-buybox-form');
    if (!optionsMount || !optionsForm) return;

    const productVariants = JSON.parse(optionsForm.querySelector('.js-product-json').textContent).variants;
    const variantMetafields = JSON.parse(optionsForm.querySelector('.js-variant-metafields').textContent);
    const displayTitles = JSON.parse(optionsForm.querySelector('.js-variant-display-titles').textContent);
    const productId = optionsForm.closest('product-form-component')?.dataset.productId || '';
    const productUrl = optionsForm.closest('product-form-component')?.dataset.productUrl || '';

    injectHelpLink(buybox);
    initAccordion(buybox);

    const moneyFormat = buybox.dataset.moneyFormat || '${{amount}}';

    function renderMoneyFormat(cents, format) {
      format = format || moneyFormat;
      const build = function (precision, thousands, decimal) {
        const num = (Math.round(cents) / 100).toFixed(precision);
        let parts = num.split('.');
        let intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts[1] ? intPart + decimal + parts[1] : intPart;
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
        switch (name) {
          case 'amount':
            return build(2, ',', '.');
          case 'amount_with_comma_separator':
            return build(2, '.', ',');
          case 'amount_with_space_separator':
            return build(2, ' ', ',');
          case 'amount_no_decimals':
            return build(0, ',', '.');
          case 'amount_no_decimals_with_comma_separator':
            return build(0, '.', ',');
          case 'amount_no_decimals_with_space_separator':
            return build(0, ' ', ',');
          default:
            return match;
        }
      });
    }

    function formatMoneySafe(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return renderMoneyFormat(cents, moneyFormat);
    }

    function getMainPriceContainers() {
      return [buybox.querySelector('.product__price')].filter(Boolean);
    }

    function getSubscriptionPriceCents(variant, meta) {
      if (!variant) return 0;
      if (meta && typeof meta.subscription_price === 'number' && meta.subscription_price > 0) {
        return Math.round(meta.subscription_price);
      }
      const discountPercent = (meta && meta.subscription_discount) || 10;
      return Math.round((variant.price * (100 - discountPercent)) / 100);
    }

    function getSelectedOptions(changedInput) {
      const selected = {};
      if (changedInput && changedInput.name) selected[changedInput.name] = changedInput.value;
      optionsForm.querySelectorAll('.js-product-option:checked').forEach(function (input) {
        if (input.name && (!changedInput || input.name !== changedInput.name)) {
          selected[input.name] = input.value;
        }
      });
      return selected;
    }

    function findVariantForOptions(candidateOptions) {
      return productVariants.find(function (v) {
        return ['option1', 'option2', 'option3'].every(function (key) {
          if (!candidateOptions[key]) return true;
          return v[key] === candidateOptions[key];
        });
      });
    }

    function updateMainProductPrice() {
      const idInput = optionsForm.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      const currentVariant = productVariants.find(function (v) {
        return String(v.id) === String(idInput.value);
      });
      if (!currentVariant) return;

      const meta = variantMetafields[currentVariant.id] || {};
      const oneTimePrice = formatMoneySafe(currentVariant.price);
      const subscriptionPrice = formatMoneySafe(getSubscriptionPriceCents(currentVariant, meta));

      getMainPriceContainers().forEach(function (container) {
        const subEl = container.querySelector('.subscription-pricing .js-price.igPrice');
        const otEl = container.querySelector('.onetime-pricing-display .js-price.igPrice');
        if (subEl) subEl.textContent = subscriptionPrice;
        if (otEl) otEl.textContent = oneTimePrice;
      });

      const titleEl = buybox.querySelector('.js-product-display-title');
      if (titleEl && displayTitles[currentVariant.id]) {
        titleEl.textContent = displayTitles[currentVariant.id];
      }
    }

    function updateSizeOptionPrices(changedInput) {
      const sizeInputs = optionsForm.querySelectorAll('fieldset.product-options__size input[type="radio"]');
      const selectedOptions = getSelectedOptions(changedInput);

      sizeInputs.forEach(function (input) {
        const sizeRaw = input.value;
        const candidateOptions = Object.assign({}, selectedOptions);
        candidateOptions.option2 = sizeRaw;
        if (changedInput && changedInput.name === 'option1') {
          candidateOptions.option1 = changedInput.value;
        }

        let variant = findVariantForOptions(candidateOptions);
        if (!variant && input.dataset.variantId) {
          variant = productVariants.find(function (v) {
            return String(v.id) === String(input.dataset.variantId);
          });
        }
        if (!variant) return;

        input.setAttribute('data-variant-id', variant.id);
        const pill = input.closest('.input-pill');
        if (!pill) return;

        const meta = variantMetafields[variant.id] || {};
        const denominator = meta.denominator > 0 ? meta.denominator : 24;
        const messageMeta = meta.message || 'Each + Free Gift';
        const subCents = getSubscriptionPriceCents(variant, meta);
        const otPer = formatMoneySafe(Math.floor(variant.price / denominator));
        const subPer = formatMoneySafe(Math.floor(subCents / denominator));

        const costOne = pill.querySelector('.cost-per-use-onetime');
        const costSub = pill.querySelector('.cost-per-use-subscription');
        if (costOne) costOne.textContent = otPer + ' ' + messageMeta;
        if (costSub) costSub.textContent = subPer + ' ' + messageMeta;

        const subPriceEl = pill.querySelector('.subscription-pricing .price.igPrice');
        const otPriceEl = pill.querySelector('.onetime-pricing-display .price.igPrice');
        if (subPriceEl) subPriceEl.textContent = formatMoneySafe(subCents);
        if (otPriceEl) otPriceEl.textContent = formatMoneySafe(variant.price);

        const subCompare = pill.querySelector('.subscription-pricing .price-compare');
        const otCompare = pill.querySelector('.onetime-pricing-display .price-compare');
        const compare = variant.compare_at_price || 0;

        if (subCompare) {
          if (compare > subCents) {
            subCompare.textContent = formatMoneySafe(compare);
            subCompare.style.display = '';
          } else {
            subCompare.style.display = 'none';
          }
        }
        if (otCompare) {
          if (compare > variant.price) {
            otCompare.textContent = formatMoneySafe(compare);
            otCompare.style.display = '';
          } else {
            otCompare.style.display = 'none';
          }
        }

        const subSaveWrap = pill.querySelector('.subscription-pricing .savings-percent-wrapper');

        if (subSaveWrap) {
          subSaveWrap.style.display = 'none';
        }
        /* B2G2 badge is static on .input-pill--b2g2, not inside price column */
      });
    }

    function syncVariant(variantId) {
      const variant = productVariants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!variant) return;

      const idInput = optionsForm.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      updateMainProductPrice();
      updateSizeOptionPrices();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());

      if (!productUrl) return;
      fetch(productUrl + '?variant=' + variant.id)
        .then(function (r) {
          return r.text();
        })
        .then(function (text) {
          const html = new DOMParser().parseFromString(text, 'text/html');
          scope.dispatchEvent(
            new CustomEvent('variant:update', {
              bubbles: true,
              detail: {
                resource: variant,
                sourceId: '',
                data: { html: html, productId: productId },
              },
            })
          );
        })
        .catch(function () {});
    }

    function handleOptionChange(evt) {
      if (!evt.target.classList.contains('js-product-option')) return;
      if (!optionsForm.contains(evt.target)) return;

      setTimeout(function () {
        updateSizeOptionPrices(evt.target);

        const selected = getSelectedOptions();
        const variant = findVariantForOptions(selected);
        if (variant) syncVariant(variant.id);
        else if (evt.target.dataset.variantId) syncVariant(evt.target.dataset.variantId);
      }, 50);
    }

    optionsForm.addEventListener('change', handleOptionChange);
    updateSizeOptionPrices();
    updateMainProductPrice();
  }

  function injectHelpLink(buybox) {
    buybox.querySelectorAll('.product-options__style .wmc-help-link').forEach(function (link) {
      link.style.margin = '0 0 0 0.25rem';
      link.style.color = '#3f858e';
    });
  }

  function initAccordion(buybox) {
    buybox.querySelectorAll('.js-accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const content = buybox.querySelector('#' + btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (!content) return;
        if (expanded) {
          content.classList.remove('is-active', 'is-visible');
        } else {
          content.classList.add('is-active');
          requestAnimationFrame(function () {
            content.classList.add('is-visible');
          });
        }
      });
    });
  }
})();
